export class ActionAlert {
  display: boolean;
  isAdd: boolean;
  message: string;
  type: 'success' | 'error' | 'info';
  constructor(
    display?: boolean,
    isAdd?: boolean,
    message?: string,
    type?: 'success' | 'error' | 'info'
  ) {
    this.display = display || false;
    this.isAdd = isAdd || true;
    this.message = message || '';
    this.type = type || 'info';
  }
}
